import type { UserData } from "../types";

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const parseUserData = (text: string): UserData => {
  const getValue = (...labels: string[]): string => {
    for (const label of labels) {
      // El valor puede venir en la misma línea o en las siguientes,
      // por eso permitimos saltos de línea entre los dos puntos y el valor.
      const regex = new RegExp(`${escapeRegExp(label)}\\s*:\\s*([^\\n]*)`, "i");
      const match = text.match(regex);
      const value = match ? match[1].trim() : "";
      if (value) return value;
    }
    return "";
  };

  return {
    rfc_company: getValue("RFC"),
    capital_regime: getValue("Régimen Capital"),
    name_company: getValue("Denominación/Razón Social"),
    public_name_company: getValue("Nombre Comercial"),
    name: getValue("Nombre (s)", "Nombre(s)", "Nombres", "Nombre"),
    lastname_1: getValue("Primer Apellido"),
    lastname_2: getValue("Segundo Apellido"),
    status_sat: getValue("Estatus en el padrón"),
    cp: getValue("Código Postal"),
    tax_regime: getValue("Régimen Fiscal", "Régimen"),
  };
};
